import { getDomainOrigin } from 'utils/serverConfig';

export const fetchMmvData = async ({ vehicle_type }) => {
    const url = `${getDomainOrigin()}/auto-insurance/mpos/mmv/?vehicle_type=${vehicle_type}`;

    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'SOURCE-ID': 'Test',
            'DATASET-LABEL': 'new',
        },
    });

    const data = await response.json();
    return data;
};
